import React, { useState } from 'react';

interface Props {
    onFormSubmit: (keyword: string) => void;
    dictSearch: string;
}

export function EventSearch(props: Props) {
    const [inputValue, setInputValue] = useState('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        setInputValue(event.target.value);
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        props.onFormSubmit(inputValue);
    };

    return (
        <>
            <form className="event-search" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="" className="sr-only sr-only-focusable">
                        Rechercher
                    </label>
                    <div className="field-icon search event">
                        <input
                            id={'this.props.keywordInputId'}
                            title={'this.props.dictJobsSkillsKeywords'}
                            type="text"
                            placeholder={props.dictSearch}
                            value={inputValue}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </form>
        </>
    );
}
